<template>
  <div id="research-overview" class="surveyOverview">
    <p class="surveyOverview-title">【調査概要】</p>
    <p class="surveyOverview-text">
      本ランキングは、当社サービス利用者の調査結果をもとにしています。当社サービスを通じて契約された順位ではなく、利用者が現在加入している火災保険会社を集計したものです。また、住宅条件や地域によって最適な保険内容は異なります。
    </p>
    <ul class="surveyOverview-list">
      <li>
        ・調査対象：株式会社ウェブクルーが運営する各種サービスの利用者のうち、メールマガジン購読者で火災保険に加入している方
      </li>
      <li>・調査期間：2026年6月10日〜6月14日</li>
      <li>・調査方法：インターネット調査</li>
      <li>・有効回答数：820件（戸建て：640件、マンション：180件）</li>
      <li>
        ・集計方法：回答結果をもとに、現在加入している火災保険会社の割合を算出しランキング化
      </li>
    </ul>
    <p class="surveyOverview-note">
      ※当ランキングは保険商品の優劣を示すものではなく、当サイトの利用者に向けて送信したアンケートの結果から作成したものとなります。
    </p>
  </div>
</template>

<style lang="scss" scoped>
.surveyOverview {
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.surveyOverview-title {
  font-size: px(12);
  font-weight: 700;
  color: $colorBasicText;
}

.surveyOverview-text {
  font-size: px(12);
  line-height: 1.5;
  color: $colorBasicText;
}

.surveyOverview-list {
  font-size: px(12);
  line-height: 1.5;
  color: $colorBasicText;
  list-style: none;
  padding: 0;

  li {
    padding-left: 1em;
    text-indent: -1em;
  }
}

.surveyOverview-note {
  padding-left: 1em;
  text-indent: -1em;
  font-size: px(12);
  line-height: 1.5;
  color: $colorBasicText;
}

@include media(pc) {
  .surveyOverview {
    padding: 0;
  }
}
</style>
